import React from 'react';
import { ReactComponent as Logo } from './logo.svg';

function EasilLogo() {
  return (
    <Logo />
  );
}

export default EasilLogo;